/**
 * purchaseDialog
 * 
 * 使用说明:
 * 
 * this.$toast('加载完毕');
 * 
 */
import Component from './purchaseDialog.vue'

const OBJ = {};

// 注册OBJ
OBJ.install = function (Vue) {
    // 生成一个Vue的子类
    // 同时这个子类也就是组件
    const Constructor = Vue.extend(Component)
    // 生成一个该子类的实例
    const instance = new Constructor();

    // 将这个实例挂载在我创建的div上
    // 并将此div加入全局挂载点内部
    instance.$mount(instance.$el)
    document.body.appendChild(instance.$el)

    // 通过Vue的原型注册一个方法
    // 让所有实例共享这个方法 
    Vue.prototype.$showPurchaseDialog = (cb) => {
        instance.show = true;
        instance.gotoWalletCb = cb;
    }

    Vue.prototype.$hidePurchaseDialog = () => {
        instance.show = false;
    }
}

export default OBJ


// WEBPACK FOOTER //
// ./src/components/global/purchaseDialog/index.js